/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SafetyWarning,
} from '../models/index';
import {
    SafetyWarningFromJSON,
    SafetyWarningToJSON,
} from '../models/index';

export interface Create1Request {
    safetyWarning: SafetyWarning;
}

export interface Delete1Request {
    id: string;
}

export interface Update1Request {
    id: string;
    safetyWarning: SafetyWarning;
}

/**
 * 
 */
export class SafetyWarningControllerApi extends runtime.BaseAPI {

    /**
     */
    async create1Raw(requestParameters: Create1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SafetyWarning>> {
        if (requestParameters['safetyWarning'] == null) {
            throw new runtime.RequiredError(
                'safetyWarning',
                'Required parameter "safetyWarning" was null or undefined when calling create1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/safety-warnings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SafetyWarningToJSON(requestParameters['safetyWarning']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SafetyWarningFromJSON(jsonValue));
    }

    /**
     */
    async create1(requestParameters: Create1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SafetyWarning> {
        const response = await this.create1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async delete1Raw(requestParameters: Delete1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling delete1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/safety-warnings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async delete1(requestParameters: Delete1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.delete1Raw(requestParameters, initOverrides);
    }

    /**
     */
    async getAll1Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SafetyWarning>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/safety-warnings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SafetyWarningFromJSON));
    }

    /**
     */
    async getAll1(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SafetyWarning>> {
        const response = await this.getAll1Raw(initOverrides);
        return await response.value();
    }

    /**
     */
    async update1Raw(requestParameters: Update1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SafetyWarning>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling update1().'
            );
        }

        if (requestParameters['safetyWarning'] == null) {
            throw new runtime.RequiredError(
                'safetyWarning',
                'Required parameter "safetyWarning" was null or undefined when calling update1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/safety-warnings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SafetyWarningToJSON(requestParameters['safetyWarning']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SafetyWarningFromJSON(jsonValue));
    }

    /**
     */
    async update1(requestParameters: Update1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SafetyWarning> {
        const response = await this.update1Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
